export default "__VITE_ASSET__7e1faa17__"